import List from "@/components/list";
import vue from "@/main";
import router from "@/router";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };

  // 编辑试题
  function editQuestion({ uuid, refNumber }) {
    router.push({ path: "/examQuestion/edit", query: { id: uuid, num: refNumber } });
  }

  // 删除试题
  function deleteQuestion({ uuid }) {
    vue.$emit("deleteQuestion", uuid );
  }

  //查看试题关联的试卷
  function previewExamPaper({ uuid }) {
    vue.$emit("previewPaper", uuid);
  }

  const Deal = ({ props: { vo } }) => {
    const question = vo.row;
    const dealConf = [
      [
        "icon-edit",
        "编辑",
        () => {
          editQuestion(question);
        },
        "examQuestion:update"
      ],
      [
        "icon-delete",
        "删除",
        () => {
          deleteQuestion(question);
        },
        "examQuestion:delete"
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "试题题干",
      prop: "questionTitle",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "试题分类",
      prop: "questionCategoryName",
      width: "100"
    },
    {
      label: "试题主题",
      prop: "questionTheme",
      minWidth: "100"
    },
    {
      label: "试题类型",
      prop: "examQuestionTypeName",
      width: "100"
    },
    {
      label: "关联试卷数",
      width: "120",
      render: vo => (
        <el-button
          type="text"
          onClick={() => {
            previewExamPaper(vo.row);
          }}
        >
          {vo.row.refNumber}
        </el-button>
      )
    },
    {
      label: "创建时间",
      prop: "createDate",
      width: "180"
    },
    {
      label: "操作",
      fixed: "right",
      width: "150",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
